import { HStack, Box, Text, useColorModeValue } from '@ecoinvent/ui';

import { FlowDetailSuppliers } from 'hooks/data/datasets/V4/flows/types';

type LegendProps = {
  supplierTypes: FlowDetailSuppliers['type'][];
  getSourceColor: (type: FlowDetailSuppliers['type']) => string;
};

export const Legend = ({ supplierTypes, getSourceColor }: LegendProps) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.800', 'gray.100');

  return (
    <HStack
      spacing={4}
      pointerEvents="none"
      backgroundColor={cardBg}
      px={4}
      py={2}
      borderRadius="md"
      border="1px solid"
      borderColor={borderColor}
      shadow="sm"
    >
      {supplierTypes.map((type) => (
        <HStack key={type} spacing={2}>
          <Box width="14px" height="14px" backgroundColor={getSourceColor(type)} borderRadius="sm" />
          <Text fontSize="sm" color={textColor}>
            {type}
          </Text>
        </HStack>
      ))}
    </HStack>
  );
};
